'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ToolbarIcon = require('../components/ToolbarIcon');

var _ToolbarIcon2 = _interopRequireDefault(_ToolbarIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INLINE_STYLES = [{ icon: 'a-bold', style: 'BOLD' }, { icon: 'a-italic', style: 'ITALIC' }];

exports.default = function (_ref) {
  var editorState = _ref.editorState,
      onToggle = _ref.onToggle,
      position = _ref.position;

  var currentStyle = editorState.getCurrentInlineStyle();
  var styles = require('./Toolbars.scss');
  return _react2.default.createElement(
    'div',
    { className: styles.toolbar, style: position },
    _react2.default.createElement(
      'ul',
      { className: styles.toolbarIcons },
      INLINE_STYLES.map(function (type) {
        return _react2.default.createElement(_ToolbarIcon2.default, {
          key: type.label || type.icon,
          active: currentStyle.has(type.style),
          label: type.label,
          icon: type.icon,
          onMouseDown: function onMouseDown() {
            onToggle(type.style);
          }
        });
      })
    )
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RichEditor/components/InlineToolbar.js
// module id = 1200
// module chunks = 0